import { InjectionToken } from '@angular/core';

import { PdfViewerConfig } from './pdf-viewer.types';

export const PDF_VIEWER_CONFIG_TOKEN = new InjectionToken<PdfViewerConfig>(
  'PDF_VIEWER_CONFIG_TOKEN',
);
